/* Concrete USA theme scripts */
(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  const navToggle = document.querySelector('[data-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const navClose = document.querySelector('[data-nav-close]');

  function openNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeNav() {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  if (navToggle) navToggle.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeNav);
    });
  }

  /* ---------- Sticky header shadow ---------- */
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const onScroll = function () {
      if (window.scrollY > 8) header.classList.add('site-header--scrolled');
      else header.classList.remove('site-header--scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    const toggle = item.querySelector('[data-faq-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      const expanded = item.getAttribute('aria-expanded') === 'true';
      // optional: close others within same FAQ group
      const group = item.closest('[data-faq-group]');
      if (group) {
        group.querySelectorAll('[data-faq-item]').forEach(function (i) {
          if (i !== item) i.setAttribute('aria-expanded', 'false');
        });
      }
      item.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  });

  /* ---------- Testimonial slider (simple) ---------- */
  document.querySelectorAll('[data-testimonial-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-slider-track]');
    const prev = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    if (!track) return;
    const slides = Array.from(track.children);
    if (slides.length === 0) return;
    const step = function (dir) {
      const w = slides[0].getBoundingClientRect().width + 24;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  /* ---------- Smooth anchor scroll with header offset ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      const id = a.getAttribute('href');
      if (!id || id === '#' || id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const headerH = header ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerH - 8;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  /* ---------- Reveal-on-scroll (subtle) ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  }
})();
